import { useState, type FunctionComponent } from 'react';
import MainLayout from '@layouts/main';
import { useSession } from 'next-auth/react';
import PersonSearch from '@components/person-search';
import type { PersonBase } from '@domain/person';
import PersonView from '@components/person-view';
import { EuiSpacer } from '@elastic/eui';

const Index: FunctionComponent = () => {
  const { status } = useSession();
  const [person, setPerson] = useState<PersonBase | null>(null);

  return (
    <MainLayout
      alignment="top"
      panelled={false}
      showSpinner={status === 'loading'}>
      <PersonSearch value={person} onChange={setPerson} />
      <EuiSpacer size="m" />
      {person != null && <PersonView idnumber={person.idnumber} />}
    </MainLayout>
  );
};

export default Index;
